module.exports = __webpack_public_path__ + "img/vertical_7_6_8019.60050888.png";